import { Line, mixins } from 'vue-chartjs';

export default {
  name: 'page-views-chart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],

  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};